import {Navigate, Outlet, useRoutes} from 'react-router-dom';
import RolesGuard from '@/context/auth/RolesGuard';
import {Roles} from '@/utils/roles';
import HomePage from '@/modules/home/templates';
import CompactLayout from "@commons/layouts/compact";
import BranchRedirect from "@modules/branch/pages/redirect";
import DashboardLayout from '../commons/layouts/dashboard';
import AuthGuard from '../context/auth/AuthGuard';
import GuestGuard from '../context/auth/GuestGuard';
import {LoginPage} from '../modules/auth';
import {orders_routers} from './orders';
import {products_routers} from './products';
import {reservations_routers} from './reservations';
import {users_routers} from './users';
import {cash_register_routers} from './cash-register';
import {monitoring_routers} from './monitoring';
import { tables_routers } from './tables';

export const Router = () => useRoutes([
        {path: '/', element: <Navigate to="/auth/login" replace/>},
        {
            path: 'dashboard',
            element: (
                <AuthGuard>
                    <DashboardLayout/>
                </AuthGuard>
            ),
            children: [
                {element: <Navigate to="/dashboard/app" replace/>, index: true},
                {path: 'app', element: <HomePage/>},
             
                orders_routers(),
                users_routers(),
                products_routers(),
                reservations_routers(),
                cash_register_routers(),
                monitoring_routers(),
                tables_routers(),
            ],
        },
        {
            path: 'auth',
            children: [
                {
                    path: 'login',
                    element: (
                        <GuestGuard>
                            <LoginPage/>
                        </GuestGuard>
                    ),
                },
            ],
        },
        {
            path: 'branch',
            element:
                <CompactLayout>
                    <BranchRedirect/>
                </CompactLayout>
        },
    ]);
